import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import funcoesGerais from '../../../funcoes/funcoesGerais';


@Component({
  selector: 'app-cancelar-pedido',
  templateUrl: './gerar-boleto-dialog.html',
  styleUrls: ['./gerar-boleto-dialog.scss', '../../../styles/estilo.padrao.scss']
})

export class GerarBoletoDialog implements OnInit {
  uid;
  boletoForm: FormGroup;
  minDate: Date = new Date();

  constructor(
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private dialogRef: MatDialogRef<GerarBoletoDialog>,
    @Inject(MAT_DIALOG_DATA) public data: { valor: number, timestampPedido: string, prazoBoleto: number }
  ) {
    this.uid = localStorage.getItem('uid');
    this.minDate.setDate(new Date().getDate() + 1);
  }

  ngOnInit(): void {
    this.boletoForm = this.formBuilder.group({
      valor: [this.data.valor, [Validators.required, Validators.min(0.01)]],
      dataVencimento: [funcoesGerais.adicionarDiasDataVencimento(new Date(), this.data.prazoBoleto), [Validators.required]],
      prazoBoleto: [this.data.prazoBoleto, null],
      observacao: ['', null],
    });


    this.boletoForm.get('prazoBoleto').disable();
  }

  dateChanged(event: any): void {
    this.boletoForm.get('dataVencimento').patchValue(new Date(event.value));
  }

  confirmarGerarBoleto() {
    if (this.boletoForm.valid) {
      this.dialogRef.close({ valor: this.f.valor.value, dataVencimento: this.f.dataVencimento.value, observacao: this.f.observacao.value });

    } else {
      this.toastr.error('Preencha todos os campos corretamente!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
      this.boletoForm.markAllAsTouched();
    }
  }

  cancelar() {
    this.dialogRef.close();
  }

  // convenience getter for easy access to form fields
  get f() { return this.boletoForm.controls; }

}
